/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:52:57]
Permissions to update outside the main branch: [false]
*/

import { WorkplaceSetting } from '@finbeat/react-toolkit';
import { AxiosInstance } from 'axios';

export const getWorkplaceSettingsOnTechnicalWorks = async (axios: AxiosInstance) => {
    const { data } = await axios.get<WorkplaceSetting[]>('/workplacesettings/onTechnicalWorks');
    return data;
};

export const getWorkplaceSettingsAll = async (axios: AxiosInstance) => {
    const { data } = await axios.get<WorkplaceSetting[]>('/workplacesettings');
    return data;
};

export const updateTechnicalWorksSettings = async (
    axios: AxiosInstance,
    settings: WorkplaceSetting[]
) => {
    const { data } = await axios.post('/workplacesettings', settings);
    return data;
};
